module.exports = __webpack_public_path__ + "dfd25b88d3660d236c00fd9b79861dac.svg";